import { defineMessages } from 'react-intl';

export const messages: {
	label: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	searchPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	viewAllRecentItemsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	label: {
		id: 'navigation.global-side-navigation.recents.label',
		description: 'Label on Recent button in the side navigation. Shows a flyout with recent items.',
		defaultMessage: 'Recent',
	},
	searchPlaceholder: {
		id: 'navigation.global-side-navigation.recentsSearchPlaceholder',
		description: 'Placeholder for the search input in the recents flyout list.',
		defaultMessage: 'Search recent items',
	},
	viewAllRecentItemsLabel: {
		id: 'navigation.global-side-navigation.recents.viewAllRecentsLabel',
		description: 'Label on View all recent items button in the recents flyout list.',
		defaultMessage: 'View all recent items',
	},
});
